class ClientAdminService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    /***
     * Create a new client.
     *
     * @param clientName    the name of the client.
     * @param groupIds      a list of IDs
     */
    createClient(clientName, groupIds, siteID) {
        const data = {
            name: clientName,
            group_ids: groupIds,
            site_id: siteID
        };
        return this.$http.post(`${this.appConfig.apiUrl}/clients/`, data);
    }

    /***
     * Delete the given client.
     * NOTE: all deletes are soft deletes and are actually only deactivated in the database.
     *
     * @param client        the client being deleted.
     * @param isActive      0 if the client is being deactivated, 1 if reactivated
     *
     * @returns {Promise}
     */
    deleteClient(client, isActive) {
        const data = {
            is_active: isActive
        };
        return this.$http.patch(`${this.appConfig.apiUrl}/clients/${client.id}/`, data)
    }

    /***
     * Get all of the available Client Groups.
     */
    getGroups() {
        return this.$http.get(`${this.appConfig.apiUrl}/groups/`)
            .then((successResponse) =>  successResponse.data);
    }

    /***
     * Gets all the facilities along with their client and location
     */
    getAllFacilities() {
        return this.$http.get(`${this.appConfig.apiUrl}/facilities/all/`)
            .then((successResponse) => successResponse.data);
    }

    /***
     * Gets all the campuses along with their client
     */
    getAllCampuses() {
        return this.$http.get(`${this.appConfig.apiUrl}/campuses/all/`)
            .then((successResponse) => successResponse.data);
    }

}

export default ClientAdminService;


// WEBPACK FOOTER //
// ./app/components/client-admin/client-admin-service.js